import { Type } from '@angular/core';
import { ConfigurationId } from '@types';
import { FundTitleComponent } from '@products/fund-header/fund-title/fund-title.component';
import { SummaryComponent } from '@products/fund-header/summary/summary.component';
import { FundHeaderDisplayComponent } from '@products/fund-header/fund-header-display-component.interface';

export class FundHeaderComponentConfig {
  static readonly FUND_TITLE = new FundHeaderComponentConfig(
    'Fund Title',
    FundTitleComponent,
    ConfigurationId.GW
  );
  static readonly SUMMARY = new FundHeaderComponentConfig(
    'Fund Summary',
    SummaryComponent,
    ConfigurationId.GW
  );

  static allConfigs: FundHeaderComponentConfig[] = [
    FundHeaderComponentConfig.FUND_TITLE,
    FundHeaderComponentConfig.SUMMARY,
  ];

  // returns matching config or undefined
  static getConfig(
    key: string,
    configurationName: ConfigurationId
  ): FundHeaderComponentConfig {
    return this.allConfigs.find((config: FundHeaderComponentConfig): boolean =>
      config.configurationName
        ? config.key === key && config.configurationName === configurationName // if config is GW or ETF specific,make sure it matches
        : config.key === key
    ); // otherwise just match on key
  }

  private constructor(
    private readonly key: string,
    public readonly component: Type<FundHeaderDisplayComponent>,
    public readonly configurationName?: ConfigurationId
  ) {}
}
